import { useLocation, useRoutes } from 'react-router-dom';
import { AuthLayout, NonAuthLayout } from '../components/Layouts/PageLayout';
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from './routes';
import FinishSetup from '../pages/Authentication/FinishSetup';

const PublicRouteWrapper = () => {
  const routes = useRoutes(PUBLIC_ROUTES);
  return routes;
};

const PrivateRouteWrapper = () => {
  const routes = useRoutes(PRIVATE_ROUTES);
  return routes;
};

const Pages = () => {
  const isAuthenticated = !!sessionStorage.getItem('accessToken');
  const location = useLocation();

  if (isAuthenticated && location.pathname === '/finish-setup') {
    return (
      <NonAuthLayout>
        <FinishSetup />
      </NonAuthLayout>
    );
  }

  return isAuthenticated ? (
    <AuthLayout>
      <PrivateRouteWrapper />
    </AuthLayout>
  ) : (
    <NonAuthLayout>
      <PublicRouteWrapper />
    </NonAuthLayout>
  );
};

export default Pages;
